cb.define([], function () {
	var AA_pc_industryarchives_VM_Extend = {
		doAction: function (name, viewmodel) {
		  if (this[name]) {
		    this[name](viewmodel);
		  }
		},
		init: function (viewmodel) {
			/************************************组织删除 -- start  ******************************************/
			let custorgsModel = viewmodel.get('industryorgs')
			custorgsModel.on('beforeCellValueChange',(args)=>{
				let data = custorgsModel.getData();
				data.splice(args.rowIndex, 1) // 删除当前行
				data = data.filter(v => (v.org === args.value.id && v._status!=="Delete"))
				if (data.length) {
					cb.utils.alert("行业档案不可重复分配给同一个组织，组织分配要唯一", 'warning');
					return false
				}
			})

			viewmodel.on('beforeDeleteRow',(args)=>{ 
				let childrenField = args.params.childrenField
				let _data = viewmodel.get(childrenField).getRow(args.params.params.index)
				let isCreator = typeof _data.isCreator == 'boolean' ? _data.isCreator : (_data.isCreator == 'false' ? false : true)
				if (isCreator) { // 组织
					cb.utils.alert("所属组织不允许删除", 'warning');
					return false;
				}
			})
			/************************************组织删除 -- end  ******************************************/
		},
	}
  try {
    module.exports = AA_pc_industryarchives_VM_Extend;
  } catch (error) {
  	// 当 类型 为 档案 的时候
  }
  return AA_pc_industryarchives_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_pc_industryarchives_VM.Extend.js